import * as types from './types'
import { createAction } from 'Utils/redux'

export const getInspections = createAction(types.VEHICLE_GET_INSPECTIONS, 'id')
export const getInspectionsSucceed = createAction(
  types.VEHICLE_GET_INSPECTIONS_SUCCEED,
  'id',
  'data'
)
